declare global {
    interface Array<T> {
        moveLabelToMiddle<K extends keyof T>(labelKey: K, labelValue: T[K]): Array<T>
    }
}

Array.prototype.moveLabelToMiddle = function <T, K extends keyof T>(this: Array<T>, labelKey: K, labelValue: T[K]): Array<T> {
    const index = this.findIndex((item) => item[labelKey] === labelValue)

    if (index === -1) return this

    const [obj] = this.splice(index, 1)
    const middle = Math.floor(this.length / 2)
    this.splice(middle, 0, obj)

    return this
}
